export class CurrencyUtils {
    public static getCurrencyName(currencyCode: string, locale: string): string {
        const numberFormat = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyCode,
            currencyDisplay: 'name',
            maximumFractionDigits: 0,
            signDisplay: 'auto',
        });

        const currencyNameWithNumber = numberFormat.format(1);
        const spaceIndex = currencyNameWithNumber.indexOf(' ');
        return (
            currencyNameWithNumber.charAt(spaceIndex + 1).toLocaleUpperCase(locale) +
            currencyNameWithNumber.substring(spaceIndex + 2)
        );
    }
}
